import React from 'react';

import styled from '@emotion/styled';

import { FontWeight } from '@clutter/clean';

import { CustomLink } from '@shared/custom_link';

import { CHALLENGER as T } from './tokens';

const CALIFORNIA_DO_NOT_SELL_PATH =
  '/legal/california_privacy_rights#information-sharing';

const Shell = styled.footer`
  background: ${T.color.summarySurface};
  border-top: 1px solid ${T.color.borderDefault};
  font-family: ${T.font.sans};
`;

const DESKTOP = '@media (min-width: 840px)';
const MOBILE = '@media (max-width: 839px)';

const Inner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${T.space[8]};

  ${MOBILE} {
    padding: ${T.space[24]};
  }

  ${DESKTOP} {
    padding: ${T.space[24]} ${T.space[48]};
  }
`;

const Link = styled(CustomLink)`
  font-weight: ${FontWeight.Medium};
  color: ${T.color.textTertiary};
  text-decoration: none;
  white-space: nowrap;

  ${MOBILE} {
    font-size: 10px;
    line-height: 16px;
  }

  ${DESKTOP} {
    font-size: 12px;
    line-height: 14px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

const Dot = styled.span`
  font-size: 10px;
  line-height: 16px;
  color: ${T.color.textTertiary};
`;

export const ChallengerFooter: React.FC = () => (
  <Shell>
    <Inner>
      <Link to="/help">Help center</Link>
      <Dot aria-hidden>•</Dot>
      <Link to="/legal/privacy_policy">Privacy</Link>
      <Dot aria-hidden>•</Dot>
      <Link to={CALIFORNIA_DO_NOT_SELL_PATH}>
        Do not sell or share my personal information
      </Link>
    </Inner>
  </Shell>
);
